/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrganizationPaymentCurrentPlanResponseDataFromJSON, GetOrganizationPaymentCurrentPlanResponseDataToJSON } from './GetOrganizationPaymentCurrentPlanResponseData';
export function GetOrganizationPaymentCurrentPlanResponseFromJSON(json) {
    return GetOrganizationPaymentCurrentPlanResponseFromJSONTyped(json, false);
}
export function GetOrganizationPaymentCurrentPlanResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: GetOrganizationPaymentCurrentPlanResponseDataFromJSON(json['data'])
    };
}
export function GetOrganizationPaymentCurrentPlanResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetOrganizationPaymentCurrentPlanResponseDataToJSON(value.data)
    };
}
